export const useStyles = () => {
    return {
        header: {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        }
    }
}